import { render, staticRenderFns } from "./MathTop.vue?vue&type=template&id=9277c4a0&"
import script from "./MathTop.vue?vue&type=script&lang=js&"
export * from "./MathTop.vue?vue&type=script&lang=js&"
import style0 from "./MathTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports